// tslint:disable
export enum EADataDepth {
    /**
     * @description None
     */
    None = 0,
    /**
     * @description Primary
     */
    Primary = 1,
    /**
     * @description Secondary
     */
    Secondary = 2,
    /**
     * @description Tertiary
     */
    Tertiary = 3,
    /**
     * @description Quaternary
     */
    Quaternary = 4,
    /**
     * @description Quinary
     */
    Quinary = 5,
}
(EADataDepth as any)['NONE'] = 0;
(EADataDepth as any)['PRIMARY'] = 1;
(EADataDepth as any)['SECONDARY'] = 2;
(EADataDepth as any)['TERTIARY'] = 3;
(EADataDepth as any)['QUATERNARY'] = 4;
(EADataDepth as any)['QUINARY'] = 5;
